import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaClock, FaFacebook, FaInstagram, FaTiktok, FaCalendarPlus, FaArrowRight, FaExclamationTriangle } from 'react-icons/fa';
import pb from '../pocketbase'; // Import PocketBase client
import './ContactPage.css';

const ContactPage = () => {

    const [formData, setFormData] = useState({
        nom: '',
        telephone: '',
        email: '',
        message: ''
    });

    const [status, setStatus] = useState({ loading: false, error: null, success: false });
    const [planning, setPlanning] = useState([]);
    const [closures, setClosures] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            // Fetch Planning
            const planningData = await pb.collection('planning').getFullList({ sort: 'created' });
            setPlanning(planningData);

            // Fetch Closures (upcoming only)
            const today = new Date().toISOString();
            const closuresData = await pb.collection('fermetures').getFullList({
                filter: `date >= "${today}"`,
                sort: 'date'
            });
            setClosures(closuresData);
        } catch (err) {
            console.error("Error fetching contact page data:", err);
        }
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus({ loading: true, error: null, success: false });

        try {
            // Send data to Pocketbase 'messages' collection with new schema
            await pb.collection('messages').create({
                nom: formData.nom,
                email: formData.email,
                telephone: formData.telephone,
                contenu: formData.message,
                type: 'contact',
                lu: false
            });

            setStatus({ loading: false, error: null, success: true });
            setFormData({ nom: '', telephone: '', email: '', message: '' });
            alert('Merci, votre message a bien été envoyé !');

        } catch (err) {
            console.error("Erreur d'envoi", err);
            setStatus({
                loading: false,
                error: "Une erreur est survenue lors de l'envoi. Veuillez vérifier votre connexion ou nous contacter par téléphone.",
                success: false
            });
            alert("Erreur lors de l'envoi du message.");
        }
    };

    return (
        <div className="prestations-page-wrapper">

            <section className="selection-trigger-section">
                <div className="container">
                    <div className="selector-header center">
                        <span className="premium-label">RESTEZ EN CONTACT</span>
                        <h2 className="section-title">NOUS <span className="text-gradient-blue">CONTACTER</span></h2>
                    </div>

                    <div className="intro-content-premium text-center">
                    </div>
                </div>
            </section>

            {/* Main Content */}
            <section className="contact-content-section">
                <div className="container contact-grid">

                    {/* Info Column */}
                    <div className="contact-info-col">
                        <div className="contact-details">
                            <div className="contact-item">
                                <div className="icon-box"><FaPhone /></div>
                                <div className="info-box">
                                    <h3>Téléphone</h3>
                                    <p>07 49 91 55 73</p>
                                </div>
                            </div>

                            <div className="contact-item">
                                <div className="icon-box"><FaEnvelope /></div>
                                <div className="info-box">
                                    <h3>E-mail</h3>
                                    <p>roulezpropre@gmail.com</p>
                                </div>
                            </div>

                            <div className="contact-item">
                                <div className="icon-box"><FaClock /></div>
                                <div className="info-box">
                                    <h3>Horaires</h3>
                                    {planning.length > 0 ? (
                                        <div className="contact-planning-list">
                                            {planning.map(day => (
                                                <div key={day.id} className="planning-row">
                                                    <span className="day">{day.jour}</span>
                                                    <span className="hours">
                                                        {day.ouvert ? `${day.debut} - ${day.fin}` : <span className="closed-text">Fermé</span>}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <p>Du lundi au dimanche : Sur rendez-vous</p>
                                    )}
                                </div>
                            </div>

                            {closures.length > 0 && (
                                <div className="contact-item closure-notice">
                                    <div className="icon-box warning"><FaExclamationTriangle /></div>
                                    <div className="info-box">
                                        <h3>Fermetures Exceptionnelles</h3>
                                        {closures.slice(0, 3).map(c => (
                                            <p key={c.id}>
                                                <strong>{new Date(c.date).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' })}</strong>
                                                {c.raison && ` : ${c.raison}`}
                                            </p>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="contact-socials">
                            <h3>Suivez-moi</h3>
                            <div className="social-icons">
                                <a href="https://facebook.com" target="_blank" rel="noreferrer"><FaFacebook /></a>
                                <a href="https://instagram.com" target="_blank" rel="noreferrer"><FaInstagram /></a>
                                <a href="https://tiktok.com" target="_blank" rel="noreferrer"><FaTiktok /></a>
                            </div>
                        </div>
                    </div>

                    {/* Form Column */}
                    <div className="contact-form-col">
                        <form className="contact-form" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="nom">Nom*</label>
                                <input
                                    type="text"
                                    id="nom"
                                    name="nom"
                                    value={formData.nom}
                                    onChange={handleChange}
                                    required
                                    disabled={status.loading}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="telephone">Téléphone*</label>
                                <input
                                    type="tel"
                                    id="telephone"
                                    name="telephone"
                                    value={formData.telephone}
                                    onChange={handleChange}
                                    required
                                    disabled={status.loading}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="email">E-mail*</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                    disabled={status.loading}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="message">Message*</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    rows="5"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                    disabled={status.loading}
                                ></textarea>
                            </div>

                            <button type="submit" className="submit-btn" disabled={status.loading}>
                                {status.loading ? 'ENVOI EN COURS...' : 'ENVOYER'}
                            </button>

                            {status.error && <p style={{ color: 'red', marginTop: '10px' }}>{status.error}</p>}
                            {status.success && <p style={{ color: 'green', marginTop: '10px' }}>Message envoyé avec succès !</p>}
                        </form>
                    </div>

                </div>
            </section>

            {/* Contact Footer CTA */}
            <section className="contact-footer-cta">
                <div className="container">
                    <div className="cta-box-modern">
                        <div className="cta-icon-wrapper">
                            <FaCalendarPlus />
                        </div>
                        <div className="cta-text-content">
                            <h3>Prêt à réserver ?</h3>
                            <p>Gagnez du temps en réservant votre créneau de nettoyage directement en ligne.</p>
                        </div>
                        <Link to="/reservation" className="btn btn-primary">
                            Réserver maintenant <FaArrowRight />
                        </Link>
                    </div>
                </div>
            </section>

        </div>
    );
};

export default ContactPage;
